import { render, staticRenderFns } from "./SummaryReceipt.vue?vue&type=template&id=115fda30&scoped=true&"
import script from "./SummaryReceipt.vue?vue&type=script&lang=ts&"
export * from "./SummaryReceipt.vue?vue&type=script&lang=ts&"
import style0 from "./SummaryReceipt.vue?vue&type=style&index=0&id=115fda30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../namtrung_logistics/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115fda30",
  null
  
)

export default component.exports